import Vue from "vue";

export default function () {
    if (ß.DEBUG) console.log("[app] build:", ß.BUILD_VERSION, "debug:", ß.DEBUG);

    // eslint-disable-next-line
    if (ß.DEBUG) Vue.config.devtools = true;
    // eslint-disable-next-line
    if (ß.DEBUG) Vue.config.debug = true;
}